import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LandingPageService {
  constructor(private httpClient: HttpClient) {}

  public unlockWithToken(token: any) {
    const headers = new HttpHeaders().set('Accept', 'application/json');
    return this.httpClient.post(`/users/unlock`, token, { headers });
  }

  public resendEmail(body: any) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post('/users/resend', JSON.stringify(body), { headers });
  }

  public getOrder(privilegeId: string) {
    return this.httpClient.get(`/orders/${privilegeId}/ram`);
  }
}
